module.exports = __webpack_public_path__ + "img/rate2.e300c656.svg";